export enum SixPlusPokerDealtTo {
    PLAYER = 'player',
    BOARD = 'board',
    DEALER = 'dealer',
}
